import {
  Box,
  BoxProps,
  ColorOptions,
  convertHexToRGBA,
  ModalDialogNew,
  RadioButton,
  Spacer,
  Text,
  TextProps
} from '@jfs/ui-new'
import { useState } from 'react'
import { Dimensions, FlatList } from 'react-native'
import { SvgImage } from '../../../../comps/SvgImage'
import { Colors } from '../../../../util/util'

interface SelectUserRoleModelProps {
  show: boolean
  onDismiss: () => void
  selectedValue: any
  setFieldValue: (value: any) => void
  data: []
}

export const ModelSelectUserRole = ({
  show,
  onDismiss,
  selectedValue,
  setFieldValue,
  ...props
}: SelectUserRoleModelProps) => {
  const [selectedRole, setSelectedRole] = useState(selectedValue ?? '')

  const onUserRoleSubmit = (clickedRole) => {
    setSelectedRole(clickedRole)
    setFieldValue(clickedRole)
    onDismiss()
    // pass selected value to form
  }

  return (
    <ModalDialogNew animate={true} show={show} type="bottom" backgroundColor="TRANSPARENT">
      <Box {...styles.container}>
        <Box flexDirection={'row'} align={'center'} justify={'space-between'}>
          <Text {...styles.headerText}>Select User Role</Text>
          <Box onPress={onDismiss} testID="close-user-role" underlayColor={'TRANSPARENT'}>
            <SvgImage imageName="Close" />
          </Box>
        </Box>
        <Box height={Dimensions.get('screen').height / 2} mt={20}>
          <FlatList
            showsVerticalScrollIndicator={false}
            data={props.data}
            renderItem={({ item }) => {
              return (
                <ListItem
                  item={item}
                  checkedItem={selectedRole}
                  onRoleChange={(clickedRole: string) => {
                    onUserRoleSubmit(clickedRole)
                  }}
                />
              )
            }}
          />
        </Box>
      </Box>
    </ModalDialogNew>
  )
}
interface ListItemProps {
  item: any
  checkedItem: any
  onRoleChange: any
}
export const ListItem = ({ item, checkedItem, onRoleChange }: ListItemProps) => {
  const onRoleSelected = () => {
    onRoleChange(item.value)
  }

  const selected = item.value === checkedItem

  return (
    <Box
      {...styles.languageListItemContainer}
      onPress={onRoleSelected}
      testID="select-role"
      alignItems="center"
      justifyContent={'space-between'}
      flexDirection={'row'}
      bg={convertHexToRGBA(Colors.PRIMARY, 4) as ColorOptions}
      borderColor={selected ? 'PRIMARY' : (convertHexToRGBA(Colors.PRIMARY, 24) as ColorOptions)}
      underlayColor={'TRANSPARENT'}>
      <Box flexDirection={'row'} alignItems="flex-start" f={1}>
        <Box
          width={35}
          height={35}
          borderRadius={35}
          backgroundColor={selected ? 'PRIMARY' : 'SECONDARY'}
          justify={'center'}
          alignItems="center">
          <SvgImage imageName={item?.iconId} color={'#fff'} />
        </Box>
        <Spacer size={20} direction="horizontal" />
        <Box width={'70%'} alignSelf="flex-start">
          <Text {...styles.titleText}>{item.value}</Text>
          <Spacer size={5} direction="vertical" />
          <Text {...styles.descText}>{item.desc}</Text>
        </Box>
      </Box>
      <RadioButton checked={item.value === checkedItem} size={20} onChange={() => onRoleChange(item.value)} />
    </Box>
  )
}

const styles = {
  container: {
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    backgroundColor: 'WHITE',
    p: 25,
    pt: 30,
  } as BoxProps,
  descText: {
    fontSize: 12,
    fontFamily: 'JioType-Medium',
    color: Colors.PRIMARY_GREY,
    lineHeight: 16,
  } as TextProps,
  titleText: {
    fontSize: 16,
    lineHeight: 24,
    fontFamily: 'JioType-Bold',
    color: Colors.BLACK_14,
  } as TextProps,
  headerText: {
    fontSize: 24,
    fontFamily: 'JioType-Black',
    color: Colors.BLACK_14,
  } as TextProps,
  languageListItemContainer: {
    underlayColor: 'TRANSPARENT',
    borderRadius: 10,
    marginVertical: 10,
    borderWidth: 1,
    p: 15,
  } as BoxProps,
}
